// extracted by mini-css-extract-plugin
export default {"messageBubble":"messagebubble_messageBubble__mR0kd","solid":"messagebubble_solid__dryEz"};